import React, { useRef, useEffect, useState } from "react";
import "./ChatViewer.css";
import ChatMessage from "./ChatMessage";
import ChatInput from "./ChatInput";
import botCore from "./core/botCore"; // ← wire-in bot brain
import layerLibrary from "./../canvas/LayerLibrary";

/** DRC-style left panel • clean, production look • now wired */
export default function ChatViewer({ onClose }) {
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef(null);

  // auto-scroll to bottom on new message
  useEffect(() => {
    layerLibrary.ensureLoaded?.();
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [messages]);

  // append helper
  const push = (items) => {
    if (!items || !items.length) return;
    setMessages((m) => [...m, ...items.map((it, i) => ({ id: `m_${Date.now()}_${i}`, ...it }))]);
  };

  async function handleSend(text) {
    // show user message
    setMessages((m) => [...m, { id: `u_${Date.now()}`, role: "user", text }]);

    // quick confirm keywords
    const t = (text || "").trim().toLowerCase();
    const isConfirm = /^(ok|okay|confirm|haan|ha|thik hai|theek hai)$/.test(t);

    try {
      if (isConfirm) {
        const outs = botCore.confirm();
        push(outs);
        return;
      }
      const outs = await botCore.handleUserText(text);
      push(outs);
    } catch (e) {
      push([{ role: "assistant", text: "Oops, kuch galat ho gaya. Dobara try karein." }]);
    }
  }

  return (
    <div className="bot-viewer">
      {/* Header — minimal, aligned with DRC */}
      <div className="viewer-header">
        <div className="viewer-title">Assistant</div>
        <button className="icon-button" title="Close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </div>

      {/* Messages */}
      <div className="viewer-content" ref={scrollRef}>
        {messages.map((m) => (
          <ChatMessage key={m.id} role={m.role} text={m.text} />
        ))}
      </div>

      {/* Input */}
      <div className="viewer-searchbar">
        <ChatInput onSend={handleSend} placeholder="Type a message…" />
      </div>
    </div>
  );
}
